<template>
  <v-app class="pa-0 background">
    <div class="d-flex flex-column">
      <v-row align="start" justify="center" no-gutters>
        <v-col cols="12">
          <v-main>
            <v-container class="pa-0" fluid>
              <router-view :key="$route.fullPath"></router-view>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>
export default {
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        this.$vuetify.goTo(1, { duration: '0', easing: 'linear' })
      }
    }
  }
}
</script>
